import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints19w9rda6g3rqz as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  CodeTextSemantic_getInstance26ilcf3y0fab5 as CodeTextSemantic_getInstance,
  SmallTextSemantic_getInstance3ht14r7yzc9rl as SmallTextSemantic_getInstance,
  ShadedSemantic_getInstance1fiswfajryzey as ShadedSemantic_getInstance,
  LargeTextSemantic_getInstance3ukb2tgj992rz as LargeTextSemantic_getInstance,
  BannerSemantic_getInstance18p0b4btg61q8 as BannerSemantic_getInstance,
} from '../../theme/semantics.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { shownWhen3t7othivfr11 as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  _ExcelLikeFormula___get_string__impl__klk7ep2db4efrd7vvyv as _ExcelLikeFormula___get_string__impl__klk7ep,
  evaluate15etsj5qcr9at as evaluate,
  ExcelEvaluationException1vr3sbgdrxa1l as ExcelEvaluationException,
  _ExcelLikeFormula___init__impl__5newgny7l2ajw10exm as _ExcelLikeFormula___init__impl__5newgn,
  ExcelLikeFormula3nl4zwq7og62 as ExcelLikeFormula,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/excel.mjs';
import { dashedBorderm8lc8ko2pq4e as dashedBorder } from '../../actuals/DashedBorder.js.mjs';
import { form14yrrf1aazl4g as form } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/kiteui/forms/helpers.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  Companion_instance1c40ds0jrup2e as Companion_instance,
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { roundToLong2s902lrwaad4n as roundToLong } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { ExcelParseException2l6x86zzipbp0 as ExcelParseException } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/excel/ExcelParser.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { modify1cw751ztekmcu as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { FormModule1vzulytb0ryex as FormModule } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/kiteui/forms/FormModule.mjs';
import { defaults3uorosiarf5y as defaults } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/kiteui/forms/FormModule.defaults.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_fm() {
  _init_properties_formulaTester_kt__inha8d();
  return fm;
}
var fm;
function formulaBuilder(_this__u8e3s4, input, output, formula, testValues) {
  testValues = testValues === VOID ? Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(default_0(input)) : testValues;
  _init_properties_formulaTester_kt__inha8d();
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  var showTester = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var this_0 = sizeConstraints(element, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(10));
  var tmp$ret$4 = themed(this_0, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
  var this_1 = themed(tmp$ret$4, CodeTextSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextArea())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  var tmp = formulaBuilder$lambda;
  element_0.bind_gesskf_k$(element_0.content_1, formula.lens_drj4fu_k$(tmp, formulaBuilder$lambda_0));
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$12 = themed(element_1, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_2 = themed(tmp$ret$12, SmallTextSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Button())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_2.willAddChild_hz2iwc_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (TextView())(element_2.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  element_2.willAddChild_hz2iwc_k$(element_3);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl(element_3);
  var tmp_2 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(element_3));
  element_3.invoke_bnq13k_k$(tmp_2, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(showTester) ? 'Hide formula tester' : 'Test formula');
  element_3.onStartup_vrxh3i_k$();
  element_2.addChild_2qpft2_k$(element_3);
  onClick(element_2, VOID, VOID, VOID, formulaBuilder$slambda(showTester));
  element_2.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_2);
  element_1.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_1);
  formulaTesting(shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(showTester)), input, output, formula, testValues);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
}
function formulaViewer(_this__u8e3s4, input, output, formula, label, testValues) {
  label = label === VOID ? null : label;
  testValues = testValues === VOID ? Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(default_0(input)) : testValues;
  _init_properties_formulaTester_kt__inha8d();
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  var showTester = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed(element, ShadedSemantic_getInstance().plus_duvq05_k$(LabelGapSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  if (label == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var l = label;
    // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element_0.willAddChild_hz2iwc_k$(element_1);
    element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
    element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      return l($this$invoke);
    });
    element_1.onStartup_vrxh3i_k$();
    element_0.addChild_2qpft2_k$(element_1);
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = themed(element_0, CodeTextSemantic_getInstance().plus_duvq05_k$(LargeTextSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_4, ($this$invoke) => _ExcelLikeFormula___get_string__impl__klk7ep($this$invoke.invoke_r7m7el_k$(formula).string_1));
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  element.willAddChild_hz2iwc_k$(element_3);
  element_3.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$23 = themed(element_3, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_2 = themed(tmp$ret$23, SmallTextSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (Button())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_2.willAddChild_hz2iwc_k$(element_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = new (TextView())(element_4.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  element_4.willAddChild_hz2iwc_k$(element_5);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_5);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_5));
  element_5.invoke_bnq13k_k$(tmp_7, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(showTester) ? 'Hide formula tester' : 'Test formula');
  element_5.onStartup_vrxh3i_k$();
  element_4.addChild_2qpft2_k$(element_5);
  onClick(element_4, VOID, VOID, VOID, formulaViewer$slambda(showTester));
  element_4.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_4);
  element_3.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_3);
  formulaTesting(shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(showTester)), input, output, formula, testValues);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
}
function formulaTesting(_this__u8e3s4, input, output, formula, testValues) {
  testValues = testValues === VOID ? Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(default_0(input)) : testValues;
  _init_properties_formulaTester_kt__inha8d();
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(ForcePaddingSemantic_getInstance()));
  dashedBorder(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed(element, LabelGapSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = get_bold(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, formulaTesting$lambda);
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_0.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_4, formulaTesting$lambda_0);
  element_2.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  form(element, get_fm(), input, testValues);
  // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
  // Inline function 'com.lightningkite.kiteui.views.important' call
  var this_2 = themed(element, BannerSemantic_getInstance());
  var tmp$ret$17 = themed(this_2, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_3 = get_bold(tmp$ret$17);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (TextView())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_3);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_3));
  element_3.invoke_bnq13k_k$(tmp_7, ($this$invoke) => {
    var tmp;
    try {
      var value = evaluate($this$invoke.invoke_r7m7el_k$(formula).string_1, $this$invoke.invoke_r7m7el_k$(testValues), input, output);
      var tmp_0;
      if (!(value == null) ? typeof value === 'number' : false) {
        tmp_0 = Cents__toString_impl_ko5hxm(Companion_instance.get_cents_h79cit_k$(roundToLong(value * 100)));
      } else {
        tmp_0 = toString(value);
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof ExcelEvaluationException()) {
        var e = $p;
        tmp_1 = e.message;
      } else {
        if ($p instanceof ExcelParseException()) {
          var e_0 = $p;
          tmp_1 = e_0.userMessage_astb5o_k$();
        } else {
          throw $p;
        }
      }
      tmp = tmp_1;
    }
    var result = tmp;
    return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).formulaResultLine_w5wyal_k$(toString(result));
  });
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
}
function formulaBuilder$lambda(it) {
  _init_properties_formulaTester_kt__inha8d();
  return _ExcelLikeFormula___get_string__impl__klk7ep(it.string_1);
}
function formulaBuilder$lambda_0(it) {
  _init_properties_formulaTester_kt__inha8d();
  return new (ExcelLikeFormula())(_ExcelLikeFormula___init__impl__5newgn(it));
}
function formulaBuilder$slambda$slambda() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return !it;
  }), 1);
}
function formulaBuilder$slambda($showTester) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* modify($showTester, formulaBuilder$slambda$slambda(), $completion);
    return Unit_instance;
  }), 0);
}
function formulaViewer$slambda$slambda() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return !it;
  }), 1);
}
function formulaViewer$slambda($showTester) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* modify($showTester, formulaViewer$slambda$slambda(), $completion);
    return Unit_instance;
  }), 0);
}
function formulaTesting$lambda($this$invoke) {
  _init_properties_formulaTester_kt__inha8d();
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_formulaTesterHeading_uddkg6_k$();
}
function formulaTesting$lambda_0($this$invoke) {
  _init_properties_formulaTester_kt__inha8d();
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_formulaTesterInstructions_a6kdjz_k$();
}
var properties_initialized_formulaTester_kt_34q0qd;
function _init_properties_formulaTester_kt__inha8d() {
  if (!properties_initialized_formulaTester_kt_34q0qd) {
    properties_initialized_formulaTester_kt_34q0qd = true;
    // Inline function 'kotlin.apply' call
    var this_0 = new (FormModule())();
    defaults(this_0);
    fm = this_0;
  }
}
//region block: exports
export {
  formulaBuilder as formulaBuilderqnttj5yf43zm,
  formulaViewer as formulaViewer2404fzigtyleo,
};
//endregion

//# sourceMappingURL=formulaTester.mjs.map
